module.exports = __webpack_public_path__ + "static/img/oil_c.9187c55.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/oil_c.png
// module id = KG6A
// module chunks = 1